export default __webpack_public_path__ + "static/logo-01-c02715eccff10abe0b6d4820f9c1c801.png";